import React from "react";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { WHATSAPP_URL } from "../mock";

const ApplyFormSuccess = ({ name, onReset }) => {
  const firstName = name ? `, ${name.split(" ")[0]}` : "";
  return (
    <div className="py-6 md:py-10">
      <div className="text-center">
        <div className="mx-auto h-16 w-16 rounded-2xl bg-emerald-500/15 grid place-items-center border border-emerald-500/30">
          <CheckCircle2 className="h-8 w-8 text-emerald-400" />
        </div>
        <span className="mt-5 inline-flex items-center gap-2 rounded-full bg-emerald-500/15 border border-emerald-500/30 px-3 py-1 text-emerald-300 text-[11px] tracking-[0.18em] uppercase font-semibold">
          Application received
        </span>
        <h3 className="mt-4 text-white text-[26px] md:text-[32px] font-semibold tracking-tight">
          Thank you{firstName}!
        </h3>
        <p className="mt-3 text-slate-300 text-[14.5px] md:text-[15.5px] leading-relaxed max-w-md mx-auto">
          Your eligibility request is in. A counsellor will reach out within working hours to confirm your cashback and next steps.
        </p>
      </div>

      <div className="mt-7 rounded-2xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/[0.10] via-[#0e1626] to-emerald-500/[0.04] p-5 md:p-6">
        <div className="flex items-start gap-3">
          <div className="h-11 w-11 rounded-xl bg-emerald-500/15 grid place-items-center border border-emerald-500/30 flex-shrink-0">
            <MessageCircle className="h-5 w-5 text-emerald-300" />
          </div>
          <div className="min-w-0">
            <div className="text-emerald-300 text-[11px] tracking-[0.18em] uppercase font-semibold">Get a faster response</div>
            <div className="mt-1 text-white text-[17px] md:text-[19px] font-semibold leading-snug">
              Message us on WhatsApp now <span className="text-amber-400">+91 98240 27940</span>
            </div>
            <p className="mt-2 text-slate-300 text-[13.5px] leading-relaxed">
              Skip the queue. Send a quick "Hi" and a counsellor will reply in minutes during business hours. Share your exam fee receipt to fast-track your cashback verification.
            </p>
          </div>
        </div>

        <div className="mt-5 grid sm:grid-cols-2 gap-2.5">
          <Button
            asChild
            className="h-12 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white text-[14.5px] font-semibold shadow-lg shadow-emerald-500/25"
          >
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2"
            >
              <MessageCircle className="h-4 w-4" /> Open WhatsApp chat
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            className="h-12 rounded-xl bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-white text-[14.5px]"
          >
            <a href="tel:+919824027940" className="inline-flex items-center justify-center gap-2">
              Call +91 98240 27940
            </a>
          </Button>
        </div>

        <ul className="mt-5 grid sm:grid-cols-3 gap-2 text-[12.5px] text-slate-300">
          <li className="inline-flex items-center gap-1.5"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> Reply in minutes</li>
          <li className="inline-flex items-center gap-1.5"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> Share documents safely</li>
          <li className="inline-flex items-center gap-1.5"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> No spam, ever</li>
        </ul>
      </div>

      <div className="mt-5 text-center">
        <button
          type="button"
          onClick={onReset}
          className="text-slate-400 hover:text-white text-[13px] underline-offset-4 hover:underline"
        >
          Submit another application
        </button>
      </div>
    </div>
  );
};

export default ApplyFormSuccess;
